@if (model$ | async; as model) {
  <app-report-header i18n-header header="Sales Deposit Invoice" [model]="model.sellingCompany"></app-report-header>
  <app-report-header-details
    i18n-addressTitle
    i18n-additionalAddressTitle
    addressTitle="Account Address"
    additionalAddressTitle="Delivery Address"
    [address]="model.customerAddress"
    [additionalAddressee]="model.deliveryAddressee"
    [additionalAddress]="
      model.deliveryAddress ? model.deliveryAddress : model.printDeliveryAddress ? model.customerAddress : ''
    "
    [summaryItems]="headerSummaryItems(model)"
  ></app-report-header-details>
  <app-report-value-pairs [summaryItems]="confirmationSummaryItems(model)"></app-report-value-pairs>
  <app-report-text>
    <span i18n>Thank you for ordering from {{ model.sellingCompany.name }}</span>
    <br />
    <span i18n
      >Do please read carefully the details on this Sales Deposit Invoice, and contact us if you have any queries</span
    >
  </app-report-text>
  <app-report-table
    [model]="model.salesOrderDeposits"
    [footerModel]="model"
    [bodyColumns]="lineColumns.bind(this)"
  ></app-report-table>
  <app-report-footer-columns [summaryItems]="footerSummaryItems(model)"></app-report-footer-columns>
  <app-report-footer [model]="model.sellingCompany"></app-report-footer>
}
